export class HistoryLogsEntryBase {
    action = '';
    rol = '';
    when = 0;
    who = '';
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value ?? this[key];
        });
    }
}
